import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {
    transform(values) {
        if (values) {
            const value = values.toString().replace(/\D/g, '');

            let phone = '';

            if (value.length > 12) {
                phone = value.replace(/(\d{2})?(\d{2})?(\d{5})?(\d{4})/, '+$1 ($2) $3-$4');

            } else if (value.length > 11) {
                phone = value.replace(/(\d{2})?(\d{2})?(\d{4})?(\d{4})/, '+$1 ($2) $3-$4');

            } else if (value.length > 10) {
                phone = value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');

            } else if (value.length > 9) {
                phone = value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');

            } else if (value.length > 5) {
                phone = value.replace(/^(\d{2})?(\d{4})?(\d{0,4})/, '($1) $2-$3');

            } else if (value.length > 1) {
                phone = value.replace(/^(\d{2})?(\d{0,5})/, '($1) $2');
            } else {
                if (values !== '') {
                    phone = value.replace(/^(\d*)/, '($1');
                }
            }
            return phone;
        }
    }
}
